
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refleksi-kompetensi/asesmen-refleksi",
      function () {
        return require("private-next-pages/refleksi-kompetensi/asesmen-refleksi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refleksi-kompetensi/asesmen-refleksi"])
      });
    }
  